import { ClockIcon } from "@heroicons/react/solid";

import CalendarScheduleSlotModel from "../../../models/CalendarScheduleSlotModel";
import UserProfilePictureAvatar from "../../avatar/UserProfilePictureAvatar";
import SlotTime from "../SlotTime";
import { Popover } from "@headlessui/react";
import SessionCardModal from "../../modal/SessionCardModal";
import { useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CancelSessionRequest } from "../../modal/views/CancelSessionRequest";
import { useAuth } from "../../../context/AuthContext";

export default function ExtendedUpcomingSlot({
  slot,
  onClick,
}: {
  slot: CalendarScheduleSlotModel;
  onClick: (slot: CalendarScheduleSlotModel) => void;
}) {
  const [open, setOpen] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { userType }: any = useAuth();
  const [popperElement, setPopperElement] =
    useState<HTMLDivElement | null>(null);
  const { i18n } = useTranslation();

  const [className, setClassName] = useState<string>("");

  useLayoutEffect(() => {
    // Decide if the dropdown should be open to the top or bottom
    if (!!popperElement) {
      const windowWidth = window.innerWidth;
      const { right, top } = popperElement?.getBoundingClientRect();
      const left = windowWidth - right;
      if (i18n.dir() === "ltr") {
        if (left >= 448) {
          setClassName("left-[100%] top-[0.5rem]");
        } else if (right >= 448) {
          setClassName("right-[100%] top-[0.5rem]");
        } else if (top >= 448) {
          setClassName("top-[100%]");
        } else {
          setClassName(" -top-[3%]");
        }
      } else {
        if (left >= 448) {
          setClassName("left-[100%]  top-[0.5rem]");
        } else if (right >= 448) {
          setClassName("right-[100%] top-[0.5rem]");
        } else if (top >= 448) {
          setClassName("top-[100%]");
        } else {
          setClassName(" -top-[3%]");
        }
      }
    }
  }, [popperElement]);
  return (
    <Popover
      as="div"
      ref={setPopperElement}
      className="relative w-full  z-0 m-1"
    >
      {({ open }) => (
        <>
          <Popover.Button
            role="button"
            className=" hover:bg-brandblue-700 relative block  z-0  shadow-md h-full overflow-y-auto w-full px-2 py-[6px]  rounded-md bg-brandblue-600"
          >
            <p className="text-white text-xs leading-5 font-normal flex items-center justify-between">
              <SlotTime time={slot.startTime} />
              <ClockIcon className="h-5 w-5" aria-hidden="true" />
            </p>
            <div className="mt-2 flex flex-col gap-1 text-white">
              <UserProfilePictureAvatar
                profilePictureUrl={slot.student?.profile_picture_url}
                className="w-8 h-8"
                alt={slot.student?.fullName}
              />
              <div className="flex flex-col gap-[2px] items-start">
                <h3 className="text-xs font-bold">{slot.student?.fullName}</h3>
                <p className="text-xs font-normal">
                  {slot.student?.recitation}
                </p>
              </div>
            </div>
          </Popover.Button>

          {!!slot && (
            <>
              <SessionCardModal
                session={slot}
                userType={userType}
                open={open}
                setOpen={setOpen}
                className={className}
                cancel={true}
                setIsOpen={() => {
                  setOpen(false);
                  setIsOpen(true);
                }}
              />
              <CancelSessionRequest
                isOpen={isOpen}
                session={slot}
                setIsOpen={() => setIsOpen(!isOpen)}
              />
            </>
          )}
        </>
      )}
    </Popover>
  );
}
